import * as React from "react";
import { useCallback, useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
import { DATA_LAKE_API_ROUTES } from "data-lake/Constants";
import { getDataLakeUriParams } from "data-lake/logic/Utils";
import fetch from "logic/rest/FetchProvider";
import { Button } from "components/bootstrap";
import { Link, ConfirmDialog } from "components/common";
import useUserDateTime from "hooks/useUserDateTime";
import DataLakeRoutes from "data-lake/Routes";
import RetrievalHelp from "data-lake/RetrievalHelp";
import useSelectedDataLake from "data-lake/hooks/useSelectedDataLake";
import DataLakeRetrievalActionForm from "data-lake/components/DataLakeActionModals/DataLakeRetrievalActionForm";
import usePermissions from "hooks/usePermissions";
const DataLakeSearchRetrieve = ({ streamIds, timeRange = null }) => {
  const { t } = useTranslation("enterprise_data_lake");
  const { selectedDataLake } = useSelectedDataLake();
  const [showRetrievalModal, setShowRetrievalModal] = useState(false);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const { userTimezone } = useUserDateTime();
  const { isPermitted } = usePermissions();
  const onRetrieveSubmit = useCallback(
    (values) => {
      const uriParams = getDataLakeUriParams(values, userTimezone);
      const { stream_ids, inclusion_type, field_filters, operator, data_lake_id } = values;
      fetch("POST", qualifyUrl(`${DATA_LAKE_API_ROUTES.DataLakeAPIController.bulk_retrieval().url}?${uriParams}`), {
        data_lake_id,
        stream_ids,
        inclusion_type,
        field_filters,
        operator
      }).then(() => {
        UserNotification.success(t("search_retrieve.success_notification"), t("search_retrieve.success_title"));
        setShowInfoModal(true);
      }).catch((error) => {
        UserNotification.error(t("search_retrieve.error_notification", { error: `${error}` }));
      }).finally(() => {
        setShowRetrievalModal(false);
      });
    },
    [userTimezone, t]
  );
  const successMessage = isPermitted("data_lake_config:read") ? /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "search_retrieve.success_with_overview",
      components: { overviewLink: /* @__PURE__ */ React.createElement(Link, { to: DataLakeRoutes.ARCHIVE.LIST }) }
    }
  ) : t("search_retrieve.success_contact_admin");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "link", onClick: () => setShowRetrievalModal(true) }, t("search_retrieve.from_streams", { count: streamIds.length })), showRetrievalModal && /* @__PURE__ */ React.createElement(
    DataLakeRetrievalActionForm,
    {
      modalTitle: t("search_retrieve.modal_title"),
      defaultTimeRange: timeRange,
      show: showRetrievalModal,
      onHide: () => setShowRetrievalModal(false),
      submitButtonText: t("search_retrieve.submit_button"),
      dataLakeId: selectedDataLake.id,
      streamIds,
      onSubmit: onRetrieveSubmit
    },
    /* @__PURE__ */ React.createElement("p", null, t("search_retrieve.retrieve_modal_text", { count: streamIds.length })),
    /* @__PURE__ */ React.createElement(RetrievalHelp, null)
  ), showInfoModal && /* @__PURE__ */ React.createElement(
    ConfirmDialog,
    {
      show: true,
      onConfirm: () => setShowInfoModal(false),
      hideCancelButton: true,
      title: t("search_retrieve.confirm_title"),
      btnConfirmText: t("search_retrieve.confirm_button")
    },
    successMessage
  ));
};
export default DataLakeSearchRetrieve;
